<template>
    <div>
        <NavBarLight></NavBarLight>
        <div class="content-start">
            <div class="container-fluid" id="main-container">
                <div class="row" id="challenge-content">
                    <div class="col-md-8 text-left" id="challenge-content-text">
                    
                        <div v-if="jobsObj.apply">
                            <div class="title">
                                <h4><span><img v-if="jobsObj.logo !== 'no'" alt="company icon" class="company-icon" :src="jobsObj.logo"/>{{jobsObj['.key']}}</span></h4>
                            </div><br>
                            <b-tabs content-class="mt-3" justified>
                                <b-tab title="About" :title-item-class="'tab-link'" :title-link-class="'tab-link'" active>
                                    <br>
                                    <div><b>Position:</b> {{jobsObj.position}}</div>
                                    <div><b>Location:</b> {{jobsObj.location}}</div><br><br>
                                    <div class="problem-title">
                                        <h5>About {{jobsObj.company}}</h5>
                                    </div>
                                    <div class="problem-text">
                                        {{jobsObj.about}}
                                    </div>
                                    <br><br>
                                    <div class="problem-title">
                                        <h5>Requirements</h5>
                                    </div>
                                    <div class="problem-text" v-for="(requirement, index) of jobsObj.requirements" :key="index">
                                        <span><font-awesome-icon class="fa" icon="check-circle" />{{requirement}}</span>
                                    </div>
                                </b-tab>
                                <b-tab title="How it works" :title-item-class="'tab-link'" :title-link-class="'tab-link'">
                                    <br>
                                    <div class="text-center">
                                    <img src="../assets/regular_timeline.svg"/></div>
                                </b-tab>
                            </b-tabs>
                        </div> <br><br>
                        
                    </div>
                    
                    <div class="col-md-4">
                        <RegisterCard 
                            v-bind:title="jobsObj['.key']"
                            v-bind:rewardText="jobsObj.reward"
                            v-bind:slug = "jobsObj.slug"
                            v-bind:clickCard="clickCard"
                            v-bind:deadline="jobsObj.deadline"
                            v-bind:apply="jobsObj.apply"
                            ctaText="APPLY NOW"
                            calledFrom="Apply"
                            ctaUrl="/submit-work">
                        </RegisterCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import NavBarLight from '@/components/NavBarLight.vue'
import RegisterCard from '@/components/RegisterCard.vue'
import firebase from '../services/firebase'


export default {
    name: 'Apply',
    components: {
        NavBarLight,
        RegisterCard
    },
    data: function() {
        return {
            jobs: []
        }
    },
    firebase: {
         jobs: firebase.database().ref('jobs')
    },
    computed: {
        jobsObj : function() {
            for (var key in this.jobs) {
                console.log("slug is " + this.jobs[key].slug);
                if (this.jobs[key].slug == this.$route.params.slug) {
                    console.log("slug is matched for " + this.jobs[key].slug);
                    return this.jobs[key];
                }
            }
        }
    },
    created: function() {
        mixpanel.track("entered application", 
        {
            "company_challenge": this.$route.params.slug,
            "user_id": firebase.auth().currentUser.uid,
            "email": firebase.auth().currentUser.email
        });
    },
    methods: {
        clickCard: function(slug_sent) {
           // alert("register clicked, in challenge vue, slug sent is " + slug_sent);
            mixpanel.track("application clicked register", 
            {
                "company_challenge": this.$route.params.slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
             });
            this.$router.push(this.$route.path + '/details');
        }
    }
}
</script>


<style scoped>

    .content-start {
        margin-top:58px;
    }

    .card {
		margin-top:20px; 
		margin-bottom:20px; 
		margin-right: 0%;
		margin-left: 0%;
        padding-left:7%;
        padding-right:7%;
        padding-top:7%;
        padding-bottom:2%;
        width:100%;
		border:none;
		box-shadow: 4px 2px 4px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
		cursor:pointer;
        background-color:#fff;
        color:#333;
	}

    a {
        color: #555 !important;
    }

    .tab-link {
        color:#555 !important;
    }

    #main-container {
        color:#222;
        background-color:#f8faff !important;
    }

    #challenge-content {
        margin-left:3.5%;
        margin-right:4%;
        padding-right:0%;
    }

    #challenge-content-text {
        padding-right:7%;
    }

    .company-icon {
        margin-left:0px;
        margin-right:20px; 
        width:60px;
        height:60px;
    }

    .problem-title {
        font-weight: 500;
        margin-bottom:15px;
    }

    .instruction-title {
        font-weight: 500;
        margin-bottom:10px;
    }

    .submission-title {
        font-weight: 500;
        margin-bottom:10px;
    }

    .every-instruction {
        margin-bottom:3px;
    }

    .problem-text {
        font-size: 0.9rem;
        margin-bottom:20px;
    }

    .instruction-text {
        font-size: 0.9rem;
    }

    .submission-text {
        font-size: 0.9rem;
    }

    .fa {
        margin-right:10px; 
        color:green
    }

</style>
